import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, toValue } from "vue";
import { useApi } from "@shopexperts/shared";

export function useAdminExpertDetail(expertId: Ref<number | string> | number | string) {
  const api = useApi();
  const id = computed(() => toValue(expertId));

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: computed(() => ["admin", "expert", id.value]),
    queryFn: async () => {
      return await api.admin.expertManager.getExpert({
        params: { expertId: id.value },
      });
    },
    enabled: computed(() => !!id.value),
    retry: 2,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  const expert = computed(() => data.value ?? null);

  return {
    expert,
    isLoading,
    error,
    refetch,
  };
}
